
import NewsletterFormV2 from '~/components/NewsletterFormV2'
export default {
  props: {
    headline: {
      type: String,
      required: false,
      default: null
    },
    text: {
      type: String,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: 'E-Mail'
    },
    successMessage: {
      type: String,
      required: false,
      default: 'Success'
    },
    validationError: {
      type: String,
      required: false,
      default: 'Validation Error'
    }
  },
  components: {
    NewsletterFormV2
  }
}
